// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4925":"2421e722a70200f6","9534":"69ee0a236db424bf"}[chunkId] + ".css";
};